// @flow
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { breakpoint } from '../utils/responsive';
import { Button, SecondaryButton } from './Button';
import { Text } from './Text';
import { VSpacer } from './Layout';
import { HorizontalRuler } from './HorizontalRuler';

export type ButtonData = {
  id: String,
  title: string,
  action: Function,
  type: $Values<typeof ButtonTypes>,
};

export const ButtonTypes = {
  DEFAULT: 'DEFAULT',
  PRIMARY: 'PRIMARY',
};

type Props = {
  title: string,
  text: string,
  buttons: Array<ButtonData>,
  isOpen: boolean,
};

class SimpleModalDialog extends PureComponent<Props> {
  getButton(button, index) {
    let buttonBody;

    switch (button.type) {
      case ButtonTypes.PRIMARY:
        buttonBody = (
          <Button id={button.id} onClick={button.action}>
            {button.title}
          </Button>
        );
        break;
      case ButtonTypes.DEFAULT:
      default:
        buttonBody = (
          <SecondaryButton id={button.id} onClick={button.action}>
            {button.title}
          </SecondaryButton>
        );
    }

    return (
      <ButtonContainer key={'dialogButtonContainer_' + index}>
        <VSpacer />
        {buttonBody}
        <Space />
      </ButtonContainer>
    );
  }

  render() {
    const { isOpen, title, text, buttons } = this.props;

    if (!isOpen) {
      return null;
    }

    return (
      <ModalOverlay>
        <Modal>
          <DialogTitle
            id="customized-dialog-title"
            onClose={this.onClickCloseModal}
          >
            {title}
          </DialogTitle>
          <HorizontalRuler />
          <DialogContent>
            <Text>{text}</Text>
          </DialogContent>
          <HorizontalRuler />
          <DialogActions>
            {buttons.map((button, index) => this.getButton(button, index))}
          </DialogActions>
        </Modal>
      </ModalOverlay>
    );
  }
}

export default SimpleModalDialog;

const ModalOverlay = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  opacity: 1;
  z-index: 9999;
  position: fixed;
  overflow-x: hidden;
  overflow-y: auto;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.7);
  ${breakpoint('medium')`
    padding: 2rem;
  `};
  ${breakpoint('small')`
    padding: 0rem;
  `};
`;

const Modal = styled.div`
  box-shadow: 0 0 0.625rem rgba(0, 0, 0, 0.2);
  background-color: #fff;
  ${breakpoint('large')`
    width: 100%;
    max-width: 560px;
  `};
  @media only screen and (min-width: 530px) and (max-width: 992px) {
    width: 100%;
    max-width: 530px;
  }
`;

const DialogTitle = styled.div`
  padding: 2rem 2rem 1rem 2rem;
`;

const DialogContent = styled.div`
  margin: 2rem;
  padding: 0.8rem;
  text-align: left;
  background: #fff;
  white-space: pre-line;
`;

const DialogActions = styled.div`
  display: flex;
  flex-direction: row;
  background: #fff;
  justify-content: center;
  padding: 1rem 2rem 2rem 2rem;
  flex-wrap: wrap;
`;

const ButtonContainer = styled.div`
  align-items: center;
  justify-content: center;
`;
const Space = styled.span`
  padding-right: 1rem;
`;
